// DS: i4.64
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Language: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12.371 2.009q.188-.024.37.021a9.998 9.998 0 0 1 .001 19.94 1 1 0 0 1-.373.021Q12.185 22 12 22q-.184 0-.37-.009a1 1 0 0 1-.373-.021 10 10 0 0 1-3.084-.73A10.003 10.003 0 0 1 4.929 4.928a10 10 0 0 1 6.329-2.899c.12-.03.246-.037.37-.021Q11.814 2 12 2t.371.009M9.955 13c.151 2.418.85 4.77 2.044 6.88A16 16 0 0 0 14.045 13zm6.093 0a18 18 0 0 1-1.675 6.638q.35-.108.689-.247a8 8 0 0 0 4.329-4.33A8 8 0 0 0 19.935 13zM4.065 13a8 8 0 0 0 4.873 6.39q.339.14.687.248A18 18 0 0 1 7.952 13zm5.561-8.64A7.998 7.998 0 0 0 4.066 11h3.886a18 18 0 0 1 1.674-6.64m4.747 0A18 18 0 0 1 16.048 11h3.887a8 8 0 0 0-2.278-4.657 8 8 0 0 0-3.284-1.983m-2.374-.242A16 16 0 0 0 9.955 11h4.09a16 16 0 0 0-2.046-6.882"
          clipRule="evenodd"
        />
      </svg>
    </IconWrap>
  );
};
Language.displayName = 'Language';

export default Language;
